import { render } from "./AccountVerified.vue?vue&type=template&id=0391d250&scoped=true"
import script from "./AccountVerified.vue?vue&type=script&lang=js"
export * from "./AccountVerified.vue?vue&type=script&lang=js"

import "./AccountVerified.vue?vue&type=style&index=0&id=0391d250&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0391d250"]])

export default __exports__